import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  toggle() {
    const html = document.documentElement
    const current = html.getAttribute('data-bs-theme')
    const next = current === 'dark' ? 'light' : 'dark'
    html.setAttribute('data-bs-theme', next)

    // Toggle bg-light-accent <-> bg-dark-accent
    document.querySelectorAll('.bg-light-accent, .bg-dark-accent').forEach(el => {
      el.classList.toggle('bg-light-accent', next === 'light')
      el.classList.toggle('bg-dark-accent', next === 'dark')
    })

    // Toggle bg-light <-> bg-dark
    document.querySelectorAll('.bg-light, .bg-dark').forEach(el => {
      el.classList.toggle('bg-light', next === 'light')
      el.classList.toggle('bg-dark', next === 'dark')
    })

    // Add more toggles as needed for other class pairs
  }
}